<!--首页收款提醒-->
<template>
    <div class="templete_box">
        <div class="templete">
            <div class="search_box search_box_f clearfix no_print">
                <div class="search_time search_inputBox">
                    <el-date-picker v-model="start_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="开始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="结束日期"></el-date-picker>
                </div>
                <el-input class="search_input search_inputBox" v-model="params.order_sn" placeholder="销售单号"></el-input>
                <select-down-customer ref="selectdowncustomer" class="searchCustomer" @changeselect="res=>{this.params.customer_id = res;}"></select-down-customer>
                <el-select class="search_select search_inputBox" v-model="params.salesman_id" multiple collapse-tags placeholder="销售人" @visible-change="getSelectList('user')">
                    <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <!-- <el-input class="search_select search_inputBox" v-model="params.search.order_sn" placeholder="销售单号"></el-input> -->
                <el-select class="search_select search_inputBox" v-model="params.status" placeholder="订单状态">
                    <el-option value="STATUS_WAIT_OUT_REVIEW" label="待财务审核"></el-option>
                    <el-option value="STATUS_WAIT_OUT" label="等待出库"></el-option>
                    <el-option value="STATUS_SOME_OUT" label="部分出库"></el-option>
                    <el-option value="STATUS_ALL_OUT" label="全部出库"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.settlement_status" placeholder="结算状态">
                    <!-- <el-option :value="999" label="全部结算状态"></el-option> -->
                    <el-option value="STATUS_SETTLEMENT_NONE" label="未结算"></el-option>
                    <el-option value="STATUS_SETTLEMENT_SOME" label="部分结算"></el-option>
                    <!-- <el-option :value="3" label="全部结算"></el-option> -->
                </el-select>
                <!-- <el-select class="search_select search_inputBox" v-model="params.search.rec" placeholder="开票状态">
                    <el-option :value="999" label="全部开票状态"></el-option>
                    <el-option :value="1" label="未开票"></el-option>
                    <el-option :value="2" label="已开票"></el-option>
                </el-select> -->
                <el-select class="search_select search_inputBox" v-model="params.rec" placeholder="是否开票">
                    <el-option value="IS_REC" label="是"></el-option>
                    <el-option value="NOT_REC" label="否"></el-option>
                </el-select>
                <div class="search_time search_inputBox" v-if="isShowMore">
                    <el-date-picker v-model="start_predict_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="预计收汇起始日期"></el-date-picker>
                    ~
                    <el-date-picker v-model="end_predict_time" value-format="yyyy-MM-dd" class="search_time_input" type="date" placeholder="预计收汇结束日期"></el-date-picker>
                </div>
                <div class="searchBtnList clearfix">
                        <div class="reset fcolor" @click="isShowMore=!isShowMore">{{isShowMore?'收起':'更多'}}</div>
                    <div class="reset fcolor" @click="reset">重置</div>
                    <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
                </div>
                <div class="execlInsert execlInsertHasFilter clearfix">
                    <!-- <div class="filterBtn" @click="filterDialogVisible=!filterDialogVisible;scene='finance.receivables';isGlobal=false;filter=copy_filter;"></div> -->
                    <span class="excel_btn" @click="excelExport"><i class="excel-icon"></i>excel导出</span>
                </div>
            </div>
            <!-- <div class="btnList clearfix">
                <el-button class="funcPublicBtn funcPublicBtnChecked" @click="batchOrderOut">审核通过</el-button>
            </div> -->
            <div class="tableBox no_print">
                <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @rowClick="rowClick" @getRow="getRow"></tabletem>
            </div>
            <div class="totalCal no_print">
                <div class="totalName">合计：</div>
                <div class="totalNumber">未结单数:{{totalObj.number_total}}</div>
                <div class="totalNumber">未结金额:{{totalObj.un_pay_amount_total}}</div>
            </div>
            <div class="pageBox no_print">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
            <!-- 销售单dialog START -->
            <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogC eldialogWidth no_print" :title="'销售单(销售单号：'+this.form_params.order_sn+')'" :modal="false" custom-class="full_dialog">
                <div class="dialogSearchBox">
                    <el-form class="clearfix dialogForm dialogFormB" :model="form_params" ref="saleorderA">
                        <div class="elFormBox">
                            <el-form-item  label="客户名称：" prop="customer_id">
                                <el-select v-model="form_params.customer_id" :disabled="true" filterable>
                                    <el-option v-for="list in selectMap.customer" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item  label="销售人：" prop="salesman_id">
                                <el-select v-model="form_params.salesman_id" :disabled="true">
                                    <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item  label="付款方式：" prop="payment_type_id">
                                <el-select v-model="form_params.payment_type_id" :disabled="true">
                                    <el-option v-for="list in selectMap.paymentType" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item  label="预计收汇：" prop="predict_time">
                                <el-date-picker v-model="form_params.predict_time" :readonly="true" type="date" placeholder="" size="mini"></el-date-picker>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item  label="销售日期：" prop="sales_time">
                                <el-date-picker v-model="form_params.sales_time" type="date" :readonly="true" placeholder="" size="mini"></el-date-picker>
                            </el-form-item>
                            <el-form-item  label="发货日期：" prop="delivery_time">
                                <el-date-picker v-model="form_params.delivery_time" type="date" :readonly="true" placeholder="" size="mini"></el-date-picker>
                            </el-form-item>
                        </div>
                        <div class="elFormBox elFormBoxBtnList elDialogElFormBoxCheckbox">
                            <el-form-item  label="REC：">
                                <el-checkbox v-model="form_params.rec"></el-checkbox>
                                <el-input v-model="form_params.tax_rate" readonly v-if="form_params.rec" placeholder="税率%：" class="checkbox elDialogElFormBoxCheckboxREC"></el-input>
                            </el-form-item>
                            <el-form-item  label="锁货等级：" prop="order_lock_level_id" v-if="enableConfig.indexOf('LOCK_LEVEL')!=-1">
                                <el-select v-model="form_params.order_lock_level_id" disabled @visible-change="getSelectList('lockLevel')">
                                    <el-option v-for="list in selectMap.lockLevel" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="elFormBox elDialogElFormBoxCheckbox">      
                            <!-- <el-form-item label="税率%：" v-if="form_params.rec">
                                <el-input v-model="form_params.tax_rate"></el-input>
                            </el-form-item> -->
                            <el-form-item  label="运费：">
                                <el-checkbox v-model="form_params.is_show_traffic"></el-checkbox>
                                <el-input v-model="form_params.traffic_amount" readonly v-if="form_params.is_show_traffic" placeholder="运费：" class="checkbox"></el-input>
                            </el-form-item>
                            <el-form-item  label="折扣：">
                                <el-checkbox v-model="form_params.is_discount_rate"></el-checkbox>
                                <el-input v-model="form_params.discount_rate" v-if="form_params.is_discount_rate" @input="calculationTableTotal" placeholder="折扣：" class="checkbox"></el-input>
                            </el-form-item>
                        </div>
                        <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisible=!filterDialogVisible;"></div>
                    </el-form>
                    <div class="dialogFlow">
                        <div class="editBox">
                            <div class="editList">
                                <el-table :data="listDetail" border stripe show-summary highlight-current-row size="mini" height="100%">
                                    <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                    <el-table-column label="捆包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf('bale_no')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.bale_no }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="供应商" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',supplier,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.supplier }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="品牌" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.brand }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="品名" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.breed }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="等级" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.grade }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="厚度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_thickness,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.sales_thickness }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="长度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_length,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.sales_length }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="片数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.pieces }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="层数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.layer_number }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="总宽度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_width_total,')!=-1">
                                        <template slot-scope="scope">
                                            <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                {{ scope.row.sales_width_total }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="立方" prop="sales_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_cube,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.sales_cube }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="单价" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_price,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.sales_price }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="金额(￥)" prop="sales_amount" width="100" show-overflow-tooltip v-if="billColumn.indexOf(',sales_amount,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.sales_amount }}
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div class="dialogTotal clearfix">
                            <div class="dialogTotalC">合计应收</div>
                            <div class="dialogTotalC" v-if="tableTotal.sales_amount&&tableTotal.sales_amount!=0.00">销售金额:{{tableTotal.sales_amount}}</div>
                            <div class="dialogTotalC" v-if="tableTotal.discount_amount&&tableTotal.discount_amount!=0.00">折扣金额:{{tableTotal.discount_amount}}</div>
                            <div class="dialogTotalC" v-if="tableTotal.tax_amount&&tableTotal.tax_amount!=0.00">税金:{{tableTotal.tax_amount}}</div>
                            <div class="dialogTotalC" v-if="tableTotal.traffic_amount&&tableTotal.traffic_amount!=0.00">运费:{{tableTotal.traffic_amount}}</div>
                            <div class="dialogTotalC" v-if="tableTotal.other_amount&&tableTotal.other_amount!=0.00">其它费用:{{tableTotal.other_amount}}</div>
                            <div class="dialogTotalC" v-if="tableTotal.reduce_amount&&tableTotal.reduce_amount!=0.00">优惠:{{tableTotal.reduce_amount}}</div>
                            <div class="dialogTotalC" v-if="tableTotal.pay_amount&&tableTotal.pay_amount!=0.00">应收金额:{{tableTotal.pay_amount}}</div>
                        </div>
                        <div class="remarkBox">
                            <textarea class="remarkTextarea" v-model="form_params.remark" cols="3"></textarea>
                        </div>
                        <div class="editPayBox clearfix">
                            <el-form class="" :model="form_params" ref="saleorderB">
                                <div class="editPay">
                                    <el-form-item  label="收款账户：" prop="account_id">
                                        <el-select v-model="form_params.account_id" :disabled="true">
                                            <el-option v-for="list in selectMap.account" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <div class="editName">账号：{{form_params.bank_no}}</div>
                                    <div class="editName">户名：{{form_params.account_name}}</div>
                                    <div class="editName">开户行：{{form_params.bank_name}}</div>
                                </div>
                                <div class="editPay bottom_flex">
                                    <!-- <el-form-item  label="首次付款：" prop="first_amount" style="margin-right:10px;">
                                        <el-input type="text" v-model="form_params.first_amount" :readonly="true"></el-input>
                                    </el-form-item> -->
                                    <div class="piaoMess clearfix" v-if="form_params.rec">
                                        <div class="piaoMessC">
                                            名称：{{bill.invoice_name}}<br/>
                                            开户行：{{bill.invoice_bank_name}}<br/>
                                            税号：{{bill.invoice_no}}
                                        </div>
                                        <div class="piaoMessC">
                                            账号：{{bill.invoice_bank_no}}<br/>
                                            地址：{{bill.invoice_addr}}<br/>
                                            电话：{{bill.invoice_phone}}
                                        </div>
                                    </div>
                                    <div class="clearfix">
                                        <el-form-item  label="首次付款：" prop="first_amount" style="margin-right:65px;float:left">
                                            <el-input type="text" v-model="form_params.first_amount" readonly></el-input>
                                        </el-form-item>
                                        <el-form-item label="优惠：" prop="reduce_amount" style="float:left;">
                                            <el-input type="text" v-model="form_params.reduce_amount" readonly></el-input>
                                        </el-form-item>
                                    </div>
                                    <!-- <el-form-item  label="优惠：" prop="reduce_amount">
                                        <el-input type="text" v-model="form_params.reduce_amount" :readonly="true"></el-input>
                                    </el-form-item> -->
                                </div>
                            </el-form>
                        </div>
                    </div>
                    <div class="editPersonBox clearfix">
                        <div class="editPerson">制单人：{{form_params.creator_name}}</div>
                        <div class="editPerson">审核人：{{form_params.auditor_name}}</div>
                        <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div> -->
                    </div>
                    <div class="editBtnList clearfix">
                        <div class="editTax clearfix">
                            <div class="editTaxname">客户余额：{{bill.balance}}</div>
                        </div>
                        <div class="editBtn">
                            <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="form_params.isInout" @click="addDialogVisible = true;add_params.order_id=form_params.id;add_params.order_sn=form_params.order_sn;add_params.customer_id=form_params.customer_id;add_params.bill_type=0;add_params.payment_type_id=form_params.payment_type_id;add_params.account_id=form_params.account_id;add_params.course_title='进销货款'">收款</el-button>
                            <el-button class="funcPublicBtn" v-if="form_params.isOrderOutPass" @click="OrderOut([form_params.id])">审核通过</el-button>
                            <el-button class="funcPublicBtn" v-if="form_params.isSettlement" @click="sureDialogVisible = true;sure_params.order_id=form_params.id;sure_params.amount=form_params.outstanding;sure_params_amount = form_params.outstanding;">结算</el-button>
                            <el-button class="funcPublicBtn" v-if="form_params.id&&module.indexOf(',finance-doc-receivable-print,')!=-1" @click="print(0)">打印</el-button>
                            <el-button class="funcPublicBtn" @click="openBill">开发票</el-button>
                            <el-button class="funcPublicBtn" v-if="form_params.id&&module.indexOf(',finance-doc-receivable-export,')!=-1" @click="exportExcelBill">导出</el-button>
                        </div>
                    </div>
                </div>
            </el-dialog>
            <!-- 销售单dialog END -->

            <!-- 退款单dialog START -->
            <el-dialog v-dialog-drag :visible.sync="dialogVisibleBack" class="eldialog eldialogC threeLabel eldialogWidth" :title="'退款单(退款单号：'+this.form_params.order_sn+')'" :modal="false" custom-class="full_dialog">
                <div class="dialogSearchBox">
                    <el-form class="clearfix dialogFormB dialogForm" :model="form_params" ref="saleorderA">
                        <div class="elFormBox">
                            <el-form-item  label="客户名称：" prop="customer_id">
                                <el-select v-model="form_params.customer_id" :disabled="true" filterable>
                                    <el-option v-for="list in selectMap.customer" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item  label="销售人：" prop="salesman_id">
                                <el-select v-model="form_params.salesman_id" :disabled="true">
                                    <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item  label="付款方式：" prop="payment_type_id">
                                <el-select v-model="form_params.payment_type_id" :disabled="true">
                                    <el-option v-for="list in selectMap.paymentType" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item  label="预计收汇：" prop="predict_time">
                                <el-date-picker v-model="form_params.predict_time" :readonly="true" type="date" placeholder="" size="mini"></el-date-picker>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item  label="销售日期：" prop="sales_time">
                                <el-date-picker v-model="form_params.sales_time" type="date" :readonly="true" placeholder="" size="mini"></el-date-picker>
                            </el-form-item>
                            <el-form-item  label="发货日期：" prop="delivery_time">
                                <el-date-picker v-model="form_params.delivery_time" type="date" :readonly="true" placeholder="" size="mini"></el-date-picker>
                            </el-form-item>
                        </div>
                        <div class="elFormBox">
                            <el-form-item  label="REC：">
                                <el-checkbox v-model="form_params.rec"></el-checkbox>
                            </el-form-item>
                            <el-form-item label="税率%：" v-if="form_params.rec">
                                <el-input v-model="form_params.tax_rate"></el-input>
                            </el-form-item>
                        </div>
                        <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisible=!filterDialogVisible;"></div>
                    </el-form>
                    <div class="dialogFlow">
                        <div class="editBox">
                            <div class="editList">
                                <el-table :data="listDetail" border stripe show-summary highlight-current-row size="mini" height="100%">
                                    <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                    <el-table-column label="捆包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf('bale_no')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.bale_no }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="供应商" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',supplier,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.supplier }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="品牌" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.brand }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="品名" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.breed }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="等级" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.grade }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="厚度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_thickness,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.sales_thickness }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="长度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_length,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.sales_length }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="片数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.pieces }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="层数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.layer_number }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="总宽度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_width_total,')!=-1">
                                        <template slot-scope="scope">
                                            <span @click="widthList = scope.row.sales_width;dialogVisibleWidth=true;" style="text-decoration:underline;cursor:pointer;">
                                                {{ scope.row.sales_width_total }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="立方" prop="sales_cube" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_cube,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.sales_cube }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="单价" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',sales_price,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.sales_price }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="金额(￥)" prop="sales_amount" width="100" show-overflow-tooltip v-if="billColumn.indexOf(',sales_amount,')!=-1">
                                        <template slot-scope="scope">
                                            {{ scope.row.sales_amount }}
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div class="dialogTotal clearfix">
                            <div class="dialogTotalC">合计应收</div>
                            <div class="dialogTotalC" v-if="tableTotal.sales_amount&&tableTotal.sales_amount!=0.00">销售金额:{{tableTotal.sales_amount}}</div>
                            <div class="dialogTotalC" v-if="tableTotal.discount_amount&&tableTotal.discount_amount!=0.00">折扣金额:{{tableTotal.discount_amount}}</div>
                            <div class="dialogTotalC" v-if="tableTotal.tax_amount&&tableTotal.tax_amount!=0.00">税金:{{tableTotal.tax_amount}}</div>
                            <div class="dialogTotalC" v-if="tableTotal.traffic_amount&&tableTotal.traffic_amount!=0.00">运费:{{tableTotal.traffic_amount}}</div>
                            <div class="dialogTotalC" v-if="tableTotal.other_amount&&tableTotal.other_amount!=0.00">其它费用:{{tableTotal.other_amount}}</div>
                            <div class="dialogTotalC" v-if="tableTotal.reduce_amount&&tableTotal.reduce_amount!=0.00">优惠:{{tableTotal.reduce_amount}}</div>
                            <div class="dialogTotalC" v-if="tableTotal.pay_amount&&tableTotal.pay_amount!=0.00">应收金额:{{tableTotal.pay_amount}}</div>
                        </div>
                        <div class="remarkBox">
                            <textarea class="remarkTextarea" v-model="form_params.remark" cols="3"></textarea>
                        </div>
                        <div class="editPayBox clearfix">
                            <el-form class="" :model="form_params" ref="saleorderB">
                                <div class="editPay">
                                    <el-form-item  label="收款账户：" prop="account_id">
                                        <el-select v-model="form_params.account_id" :disabled="true">
                                            <el-option v-for="list in selectMap.account" :key="list.id" :value="list.id" :label="list.name"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <div class="editName">账号：{{form_params.bank_no}}</div>
                                    <div class="editName">户名：{{form_params.account_name}}</div>
                                    <div class="editName">开户行：{{form_params.bank_name}}</div>
                                </div>
                                <div class="editPay bottom_flex">
                                    <!-- <el-form-item  label="首次付款：" prop="first_amount" style="margin-right:10px;">
                                        <el-input type="text" v-model="form_params.first_amount" :readonly="true"></el-input>
                                    </el-form-item> -->
                                    <div class="piaoMess clearfix" v-if="form_params.rec">
                                        <div class="piaoMessC">
                                            名称：{{bill.invoice_name}}<br/>
                                            开户行：{{bill.invoice_bank_name}}<br/>
                                            税号：{{bill.invoice_no}}
                                        </div>
                                        <div class="piaoMessC">
                                            账号：{{bill.invoice_bank_no}}<br/>
                                            地址：{{bill.invoice_addr}}<br/>
                                            电话：{{bill.invoice_phone}}
                                        </div>
                                    </div>
                                    <el-form-item  label="优惠：" prop="reduce_amount">
                                        <el-input type="text" v-model="form_params.reduce_amount" :readonly="true"></el-input>
                                    </el-form-item>
                                </div>
                            </el-form>
                        </div>
                    </div>
                    <div class="editPersonBox clearfix">
                        <div class="editPerson">制单人：{{form_params.creator_name}}</div>
                        <div class="editPerson">审核人：{{form_params.auditor_name}}</div>
                        <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div> -->
                    </div>
                    <div class="editBtnList clearfix">
                        <div class="editTax clearfix">
                            <div class="editTaxname">客户余额：{{bill.balance}}</div>
                        </div>
                        <div class="editBtn">
                            <el-button class="funcPublicBtn" v-if="form_params.isSettlement" @click="sureDialogVisible = true;sure_params.order_id=form_params.id;sure_params.amount=form_params.outstanding;sure_params_amount = form_params.outstanding;sure_params.remark='销售退款到余额'">结算</el-button>
                            <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="form_params.isPayment" @click="addDialogVisibleBack = true;add_params.order_id=form_params.id;add_params.order_sn=form_params.order_sn;add_params.customer_id=form_params.customer_id;add_params.bill_type=1;add_params.payment_type_id=form_params.payment_type_id;add_params.account_id=form_params.account_id;add_params.course_title='销售退款'">付款</el-button>
                        </div>
                    </div>
                </div>
            </el-dialog>
            <!-- 退款单dialog END -->

            <!-- 新增收款单 dialog START -->
            <el-dialog v-dialog-drag title="新增收款单" :visible.sync="addDialogVisible" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
                <el-form :model="add_params" ref="add_form" class="dialogFormB clearfix">
                    <div class="eldialogFormBox">
                        <el-form-item label="销售单号：">
                            <el-input v-model="add_params.order_sn" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="交易日期：">
                            <el-date-picker v-model="invoice_time" type="date" ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="我方账户：">
                            <el-select v-model="add_params.account_id" placeholder="" @visible-change="getSelectList('account')">
                                <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id" :value="item.id"  :label="item.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户名称：">
                            <el-input v-model="add_params.customer_name" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="流水类型：">
                            <el-select v-model="add_params.bill_type" placeholder="" >
                                <el-option :value="0"  label="收入"></el-option>
                                <el-option :value="1"  label="支出"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="交易方式：">
                            <el-select v-model="add_params.payment_type_id" placeholder="" @visible-change="getSelectList('paymentType')">
                                <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id" :value="item.id"  :label="item.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="科目名称：">
                            <el-input v-model="add_params.course_title" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="交易RMB金额：">
                            <el-input v-model="add_params.amount" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="备注：">
                            <el-input v-model="add_params.remark" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="dialogBtnList clearfix">
                    <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisible=!addDialogVisible">取消</el-button>
                    <el-button  class="publicBtn dialogBtn" @click="addOrderSheet">确定</el-button>
                </div>
            </el-dialog>
            <!-- 新增收款单 dialog END -->

            <!-- 新增付款单 dialog START -->
            <el-dialog v-dialog-drag title="新增付款单" :visible.sync="addDialogVisibleBack" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
                <el-form :model="add_params" ref="add_form" class="dialogFormB clearfix">
                    <div class="eldialogFormBox">
                        <el-form-item label="退货单号：">
                            <el-input v-model="add_params.order_sn" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="交易日期：">
                            <el-date-picker v-model="trading_time" disabled type="date" ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="付款账户：">
                            <el-select v-model="add_params.account_id" placeholder="" @visible-change="getSelectList('account')">
                                <el-option v-for="item in selectMap.account" :key="'add_form_account_'+item.id" :value="item.id"  :label="item.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="客户名称：">
                            <el-input v-model="add_params.customer_name" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="流水类型：">
                            <el-select v-model="add_params.bill_type" placeholder="" >
                                <el-option :value="0"  label="收入"></el-option>
                                <el-option :value="1"  label="支出"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="交易方式：">
                            <el-select v-model="add_params.payment_type_id" placeholder="" @visible-change="getSelectList('paymentType')">
                                <el-option v-for="item in selectMap.paymentType" :key="'add_form_payment_type_'+item.id" :value="item.id"  :label="item.name"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="科目名称：">
                            <el-input v-model="add_params.course_title" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="交易RMB金额：">
                            <el-input v-model="add_params.amount" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="备注：">
                            <el-input v-model="add_params.remark" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="dialogBtnList clearfix">
                    <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisibleBack=!addDialogVisibleBack">取消</el-button>
                    <el-button  class="publicBtn dialogBtn" @click="addOrderSheetBack">确定</el-button>
                </div>
            </el-dialog>
            <!-- 新增收款单 dialog END -->

            <!-- 开发票 dialog START -->
            <el-dialog v-dialog-drag title="开发票" :visible.sync="addDialogVisibleBill" class="eldialog eldialogLine" :modal="false" custom-class="full_dialog">
                <el-form :model="add_billParams" ref="add_form" class="dialogFormB clearfix">
                    <div class="eldialogFormBox">
                        <el-form-item label="交易日期：">
                            <el-date-picker v-model="trading_time" type="date" ></el-date-picker>
                        </el-form-item>
                        <el-form-item label="发票抬头：">
                            <el-input v-model="add_billParams.title" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="发票名称：">
                            <el-input v-model="add_billParams.name" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="发票号码：">
                            <el-input v-model="add_billParams.code" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="发票金额：">
                            <el-input v-model="add_billParams.amount" placeholder=""></el-input>
                        </el-form-item>
                        <el-form-item label="销售单号：">
                            <el-input v-model="add_billParams.order_sn" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="备注：">
                            <el-input v-model="add_billParams.remark" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="dialogBtnList clearfix">
                    <el-button class="dialogBtn funcPublicBtn" @click="addDialogVisibleBill=!addDialogVisibleBill">取消</el-button>
                    <el-button  class="publicBtn dialogBtn" @click="addOrderBill">确定</el-button>
                </div>
            </el-dialog>
            <!-- 开发票 dialog END -->

            <!-- 结算确认 dialog START -->
            <el-dialog v-dialog-drag title="结算确认" :visible.sync="sureDialogVisible" width="500px" class="eldialog eldialogA" :model="false">
                <el-form :model="sure_params" ref="sure_form">
                    <div class="eldialogFormBox">
                        <el-form-item label="客户余额：" class="other_form_item">
                            <div style="text-align:left;">{{bill.balance}}</div>
                        </el-form-item>
                    </div>
                    <div class="eldialogFormBox">
                        <el-form-item label="结算RMB金额：" class="other_form_item">
                            <el-input v-model="sure_params.amount" @input="settlementInput" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                    <textarea class="edit_input edit_textarea" v-model="sure_params.remark"></textarea>
                    <div class="dialogBtnList clearfix">
                        <el-button  class="publicBtn dialogBtn"  @click="settlement">确定</el-button>
                        <el-button class="dialogBtn funcPublicBtn" @click="sureDialogVisible = false">取消</el-button>
                    </div>
                </el-form>
            </el-dialog>
            <!-- 结算确认 dialog END -->
            <!-- 列表修改 dialog START -->
            <el-dialog v-dialog-drag :title="listDetailObj.type==1?'运费修改':listDetailObj.type==2?'税金修改':listDetailObj.type==3?'其他收款修改':listDetailObj.type==4?'优惠修改':''" :visible.sync="listDialogVisible" width="500px" class="eldialog eldialogA" :model="false">
                <el-form :model="sure_params" ref="sure_form">
                    <div class="eldialogFormBox">
                        <el-form-item :label="listDetailObj.type==1?'运费':listDetailObj.type==2?'税金':listDetailObj.type==3?'其他收款':listDetailObj.type==4?'优惠':''" class="other_form_item">
                            <el-input v-model="listDetailObj.amount" placeholder=""></el-input>
                        </el-form-item>
                    </div>
                    <textarea class="edit_input edit_textarea" v-model="listDetailObj.remark"></textarea>
                    <div class="dialogBtnList clearfix">
                        <el-button  class="publicBtn dialogBtn"  @click="listChangeSure">确定</el-button>
                        <el-button class="dialogBtn funcPublicBtn" @click="listDialogVisible = false">取消</el-button>
                    </div>
                </el-form>
            </el-dialog>
            <!-- 列表修改 dialog END -->
            <!--查看已开票 START-->
            <el-dialog v-dialog-drag  :visible.sync="dialogVisibleBill" class="eldialog eldialogStock" width="920px" :modal="false" title="开票记录" custom-class="full_dialog">
                <pay-list-dialog ref="selectStock" :id="seeBillList_id"></pay-list-dialog>
            </el-dialog>
            <!--查看已开票 END-->
            <!-- 字段过滤 START -->
            <filter-fields :tableData="filter" :scene="scene" :isGlobal="isGlobal" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
            <!-- 字段过滤 END -->
            <!-- 宽度列表START -->
            <el-dialog v-dialog-drag :visible.sync="dialogVisibleWidth" class="eldialog totalWidthDialog" width="820px" :modal="false" custom-class="full_dialog">
                <total-widthnew :edit="false" :list="widthList" @cancelWidth="()=>{this.dialogVisibleWidth = false;}"></total-widthnew>
            </el-dialog>
            <!-- 宽度列表END -->
        </div>
    </div>
</template>
<style scoped lang="scss">
    .piaoMess{font-size: 12px;color:#777;margin-bottom:10px;}
    .piaoMessC{float: left;width:50%;}
    .order_header{
        font-size:26px; font-weight:bold; line-height:37px; color: #333333; text-align: center; position: relative; top: 15px;
        .code{ left: 50%; position: absolute; margin-left: 154px; font-size: 12px; color: #333333; }
    }
    .bottom_flex{ padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;padding:2px 0;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;margin-right:20px;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }

    .sub_container{
        display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff;
        .filter_path{
            padding: 15px; background-color: #F4F5F9; margin-bottom: 12px;
            .form-inline{
                & > div{
                    margin-right: 20px;
                    button { margin-left: 15px; }
                }
            }
            .filter_input{
                width: 123px;
            }
        }
        .operate_row{
            display: flex; align-items: center; justify-content: space-between; padding: 0px 0 6px;
            // .excel_btn{
            //     color: #B21111; cursor: pointer;
            // }
        }
        .table_path{ flex: 1; }
        .statistics{
            background: #F7F8FA; padding: 12px 23px; line-height:18px; margin-top: 10px; display: flex; align-items: flex-start; font-size: 15px; color: #333333;
            & > div:last-child{
                flex: 1; margin-left: 26px;
                & > div:last-child{
                    margin-top: 17px;
                }
                & > div > span + span{ margin-left: 80px; }
            }
        }
        // dialog START
        .order_header{
            font-size:26px; font-weight:bold; line-height:37px; color: #333333; text-align: center; position: relative; top: 15px;
            .code{ left: 50%; position: absolute; margin-left: 154px; font-size: 12px; color: #333333; }
        }
        .order_dialog{
            .edit_select{ width: 151px; }
            .edit_input{ width: 116px; }
            .order_base{ margin-bottom: 15px; }
            .flex{
                display: flex; align-items: center; justify-content: space-between;
                & > div { margin-bottom: 12px; }
                .edit_input{ width: 151px; }
            }
            .order_other{
                display: flex; align-items: stretch; border: 1px solid #707070; border-left: 0px none;
                & > div{ flex: 1; border-left: 1px solid #707070; }
                & > div:first-child{ padding: 11px 0 9px 50px; }
                .label_no_padding_form > div{ margin-bottom: 4px; }
                .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
            }
            .order_footer{ display: flex; font-size:16px; line-height:22px; display: flex; padding: 8px 28px 0 32px; align-items: center; justify-content: space-between; }
        }
        .dialog-footer{ display: flex; align-items: center; justify-content: space-between; font-size:16px; color: #333333; }
        // dialog END
        // add_dialog START
        .add_dialog_form{
            & > div{ margin-bottom: 9px; }
            .btn_row{ padding-top: 23px; text-align: center; }
            .edit_input{ width: 100%; }
        }
        // add_dialog END
        // sure_dialog START
        .sure_dialog_form{
            & > div{ margin-bottom: 15px; }
            .btn_row{ padding-top: 23px; text-align: right; }

            .remark{
                display: flex; align-items: stretch; justify-content: space-between; background: #fff; color: #000000; font-size: 12px; padding: 5px 12px;
                textarea{ background: #FFFFFF; border-radius:3px; height:84px; resize: none; border: 0px none; outline: none; flex: 1;  }
            }
        }
        // sure_dialog END
    }
</style>
<script>
    import pagination from '../components/pagination.vue'
    import tabletem from '../components/table.vue'
    import selectDownCustomer from '../components/selectDownCustomer.vue'
    export default {
        components:{
            pagination,
            tabletem,
            selectDownCustomer
        },
        data(){
            return{
                tableLoading:false,
                module:localStorage.dw_erp_power_code,
                enableConfig:localStorage.dw_erp_enable_config,
                boardAmericaType:localStorage.dw_erp_board.indexOf("board-america")!=-1?true:false,
                boardAfricaType:localStorage.dw_erp_board.indexOf("board-africa")!=-1?true:false,
                isShowMore:false,
                dialogVisibleWidth:false,
                isGlobal:false,
                companyName:localStorage.dw_erp_company_name,
                billColumn:"",
                scene:"",
                widthList:[],
                start_time: "",
                end_time: "",
                params:{
                    page:1,
                    per_page:50,
                    // sort:"",
                    // order:"",
                    order_sn:"",
                    sales_time:"",
                    start_time:"",
                    end_time:"",
                    customer_id:"",
                    salesman_id:"",
                    settlement_status:"",
                    status:"",
                    rec:""
                },
                billRecoedParam:{
                    page: 1,
                    per_page: 50,
                    search: {
                        start_time: "",
                        end_time: "",
                        order_id: ""
                    }
                },
                seeBillList_id:"",
                last_page: 10,
                total:0,
                list : [],
                summary:{
                    sales_amount : 0,
                    reduce_amount : 0,
                    already_amount : 0,
                    outstanding_amount : 0,
                },
                selectMap:{
                    customer:[],
                    user:[],
                    account:[],
                    paymentType:[],
                    lockLevel:[]
                },
                bill:{},
                listDialogVisible:false,
                // dialog START
                dialogVisible : false,
                dialogVisibleBack:false,
                addDialogVisibleBack:false,
                addDialogVisibleBill:false,
                dialogVisibleBill:false,
                listDetail:[
                    {id:"",inventory_id:"",bale_no:"",supplier:"",brand:"",breed:"",pay_status:"",sales_length:"",sales_width_total:"",sales_cube:"",sales_price:""}
                ],
                form_params:{
                    id:"",
                    account_id:"",
                    first_amount:"",
                    reduce_amoun:"",
                    tax_rate:"",
                    sales_time:"",
                    delivery_time:"",
                    predict_time:"",
                    salesman_id:localStorage.dw_erp_user_id?parseInt(localStorage.dw_erp_user_id):"",
                    customer_id:"",
                    payment_type_id:"",
                    remark:"",
                    is_request_review:"",
                    bank_no:"",
                    account_name:"",
                    bank_name:"",
                    inventory_list:[],
                    rec:false,
                    order_lock_level_id:"",
                    is_show_traffic:0,
                    traffic_amount:"",
                    is_discount_rate:0,
                    discount_rate:"",
                    reduce_amount:0,
                    other_amount:0
                },
                add_billParams:{
                    invoice_time:"",
                    title:"",
                    order_id:"",
                    name:"",
                    code:"",
                    amount:"",
                    remark:""
                },
                invoice_time:"",
                // DIALOG END
                // 新增收款单 dialog START
                addDialogVisible: false,
                order_sn : "",
                trading_time : new Date(),
                add_params : {
                    order_id : "",
                    bill_type : "",
                    amount : "",
                    account_id : "",
                    customer_id : "",
                    trading_time :"",
                    trading_mode_id : "",
                    course_title : "进销货款",
                    remark : ""
                },
                // 新增收款单 dialog END
                // 结算确认 dialog START
                sureDialogVisible : false,
                sure_params : {
                    order_id : "",
                    amount : "",
                    remark : ""
                },
                // 结算确认 dialog END
                tableCol:[
                    {colName:"单号",colKey:"order_sn",colWidth:190,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"订单状态",colKey:"status_text",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"结算状态",colKey:"settlement_status_text",colWidth:95,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售日期",colKey:"sales_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"预计收款",colKey:"predict_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"超出天数",colKey:"overtime",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    // {colName:"结算日期",colKey:"settlement_time",colWidth:90,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售人",colKey:"salesman_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"客户名称",colKey:"customer_name",colWidth:170,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"制单人",colKey:"creator_name",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"销售金额",colKey:"sales_amount",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"折扣金额",colKey:"discount_amount",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"应收金额",colKey:"receivable_amount",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"已结金额",colKey:"already_amount",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"未结金额",colKey:"un_pay_amount",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"运费",colKey:"traffic_amount",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"税金",colKey:"tax_amount",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"其它收款",colKey:"other_amount",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"优惠",colKey:"reduce_amount",colWidth:70,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"已开票",colKey:"invoice_yes",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true},
                    {colName:"未开票",colKey:"invoice_not",colWidth:85,isSetWidth:true,isCanClick:false,isShow:true,isColor:true}
                ],
                selectRow:[],
                totalObj:{},
                listDetailObj:{order_id:"",type:"",amount:"",remark:""},
                filterDialogVisible:false,
                filter:"",
                copy_filter:"",
                fields:"",
                sure_params_amount:"",
                start_predict_time:"",
                end_predict_time:"",
                tableTotal:{
                  sales_amount:0.00,
                  discount_amount:0.00,
                  tax_amount:0.00,
                  traffic_amount:0.00,
                  other_amount:0.00,
                  reduce_amount:0.00,
                  pay_amount:0.00
                },
            }
        },
        created() {
            this.getSelectList("user")
            this.getSelectList("customer")
            this.getSelectList("account")
            this.getSelectList("paymentType")
            this.getSelectList("lockLevel")
            this.getList();
            // this.getBillColumn();
        },
        methods:{
            excelExport(){
                this.$exportExecl("/erp/export.receipt.notice","收款提醒",this.params)
            },
            settlementInput(val){
                var reg = /(^[1-9][0-9]{0,8}([.][0-9]{0,2})?$)|(^0?(\.[0-9]{0,2})?$)/;
                if(reg.test(val)){
                    this.sure_params.amount = val;
                    this.sure_params_amount = val;
                }else{
                    this.sure_params.amount = this.sure_params_amount;
                }
            },
            exportExcelBill(){
                this.$exportExecl("/erp/order.export","销售单",{id:this.form_params.id,"scene":"finance.order.column"})
            },
            filterConfirm(){
                if(this.isGlobal){
                    this.getBillColumn()
                }else{
                    this.getList()
                }
            },
            getBillColumn(){
                this.postFunc("/erp/company.column.data",{scene:this.scene},response=>{
                    this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                    this.filter = response.data.data.columns;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //点击开发票
            openBill(){
                this.invoice_time=new Date();
                this.add_billParams.order_id=this.form_params.id;
                this.add_billParams.order_sn=this.form_params.order_sn;
                this.addDialogVisibleBill=!this.addDialogVisibleBill;
                this.selectMap.customer.forEach(item=>{
                    if(item.id==this.form_params.customer_id){
                        this.add_billParams.title=item.name;
                    }
                })
            },
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            listChangeSure(){
                this.postFunc("/erp/finance.field",this.listDetailObj,()=>{
                    this.tip("修改成功","success")
                    this.getList();
                    this.listDialogVisible=false;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getBillMess(id){
                this.postFunc("/erp/customer.detail",{id:id},response=>{
                    this.bill=response.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            //结算
            settlement(){
                this.$confirm('是否确认结算?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.postFuncLoading("/erp/finance.settlement",this.sure_params,()=>{
                        this.tip("结算成功","success")
                        this.sureDialogVisible=false;
                        // this.dialogVisible=false;
                        //this.form_params.outstanding-=this.sure_params.amount;
                        let obj = {name:"order_sn",id:this.form_params.id}
                        this.rowClick(obj)
                        this.getBillMess(this.form_params.customer_id)
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            //添加付款单
            addOrderSheetBack(){
                this.$confirm('是否确认付款?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.add_params.trading_time=parseInt(this.trading_time.getTime()/1000)
                    this.postFuncLoading("/erp/finance.inout",this.add_params,()=>{
                        this.tip("付款成功","success")
                        this.addDialogVisibleBack=false;
                        // this.dialogVisible=false;
                        this.getBillMess(this.form_params.customer_id)
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            //开发票
            addOrderBill(){
                this.$confirm('是否确认开发票?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.add_billParams.invoice_time=this.formatTimeZero(this.invoice_time)
                    this.postFuncLoading("/erp/invoice.create",this.add_billParams,()=>{
                        this.tip("操作成功","success")
                        this.addDialogVisibleBill=false;
                        // this.dialogVisible=false;
                        // this.getBillMess(this.form_params.customer_id)
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            //添加收款单
            addOrderSheet(){
                this.$confirm('是否确认收款?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.add_params.trading_time=parseInt(this.trading_time.getTime()/1000)
                    this.postFuncLoading("/erp/finance.inout",this.add_params,()=>{
                        this.tip("收款成功","success")
                        this.addDialogVisible=false;
                        // this.dialogVisible=false;
                        this.getBillMess(this.form_params.customer_id)
                        this.getList()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{});
            },
            getRow(row){
                this.selectRow=row;
            },
            selectAccount(val){
                this.selectMap.account.forEach(item=>{
                    if(item.id==val){
                        this.form_params.bank_no=item.bank_no;
                        this.form_params.account_name=item.account_name;
                        this.form_params.bank_name=item.bank_name;
                    }
                })
            },
            //计算合计
            calculationTableTotal(){
            let sales_amount = 0;
            let discount_amount = 0;
            let tax_amount = 0;
            let traffic_amount = 0;
            let other_amount = 0;
            let reduce_amount = 0;
            if(this.listDetail.length>0){
                this.listDetail.forEach(item=>{
                    if(item.sales_cube&&item.sales_price){
                        this.calcu(item.sales_cube,item.sales_price,"mul",res=>{
                            this.calcu(sales_amount,res,"add",val=>{
                                sales_amount = val
                            },2)
                        },2)
                    }
                })
            }
            if(this.form_params.is_discount_rate==1){
                if(this.form_params.discount_rate){
                    this.calcu(this.form_params.discount_rate,sales_amount,"mul",res=>{
                        this.calcu(sales_amount,res,"reduce",val=>{
                            discount_amount = val
                        },2)
                    },2)
                }else{
                    discount_amount = 0
                }
            }
            if(this.form_params.rec==1){
                this.calcu(sales_amount,discount_amount,"reduce",res=>{
                    this.calcu(this.form_params.tax_rate,100,"div",ret=>{
                        this.calcu(res,ret,"mul",val=>{
                            tax_amount = val
                        },2)
                    },4)
                },2)
            }else{
                tax_amount = 0
            }
            if(this.form_params.is_show_traffic==1){
                traffic_amount = this.form_params.traffic_amount;
            }else{
                traffic_amount = 0;
            }
            if(this.form_params.other_amount){
                other_amount = this.form_params.other_amount
            }else{
                other_amount = 0;
            }
            if(this.form_params.reduce_amount){
                reduce_amount = this.form_params.reduce_amount
            }else{
                reduce_amount = 0;
            }
            this.tableTotal.sales_amount = sales_amount;
            this.tableTotal.discount_amount = discount_amount;
            this.tableTotal.tax_amount = tax_amount;
            this.tableTotal.traffic_amount = traffic_amount;
            this.tableTotal.other_amount = other_amount;
            this.tableTotal.reduce_amount = reduce_amount;
            this.calcu(sales_amount,tax_amount,"add",a=>{
                this.calcu(a,traffic_amount,"add",b=>{
                    this.calcu(b,other_amount,"add",c=>{
                        this.calcu(c,discount_amount,"reduce",d=>{
                            this.calcu(d,reduce_amount,"reduce",e=>{
                                this.tableTotal.pay_amount = e;
                            },2)
                        },2)
                    },2)
                },2)
            },2)
        },
            rowClick(obj){
                if(obj.name=="order_sn"){
                    this.postFunc("/erp/order.order",{id:obj.id},res=>{
                        if(res.data.data.status_text=="退货单"){
                            this.dialogVisibleBack=true;
                            this.scene = 'finance.return.column';
                            this.isGlobal = true;
                            this.getBillColumn();
                        }else{
                            this.scene='finance.order.column';
                            this.isGlobal = true;
                            this.getBillColumn();
                            this.dialogVisible = true;
                        }
                        let resD = res.data.data;
                        if(resD.rec_type=='DIV'){
                            resD.rec_type = 2
                        }else{
                            resD.rec_type = 1
                        }
                        this.form_params=res.data.data;
                        res.data.data.details.forEach(item=>{
                            item.totalPrice=parseFloat(Number(item.sales_cube)*Number(item.sales_price)).toFixed(2)
                        })
                        this.form_params.account_id==0?this.form_params.account_id="":"";
                        this.form_params.payment_type_id==0?this.form_params.payment_type_id="":"";
                        this.invoice_time = Number(this.form_params.sales_time)?Number(this.form_params.sales_time)*1000:new Date();
                        this.listDetail=JSON.parse(JSON.stringify(res.data.data.details));
                        this.selectAccount(res.data.data.account_id)
                        this.list.forEach(item=>{
                            if(item.id==obj.id){
                                this.form_params.outstanding=item.outstanding;
                                if(item.isOrderOutPass){
                                    this.form_params.isOrderOutPass=true;
                                }
                                if(item.isInout){
                                    this.form_params.isInout=true;
                                }
                                if(item.isSettlement){
                                    this.form_params.isSettlement=true;
                                }
                                if(item.isPayment){
                                    this.form_params.isPayment=true;
                                }
                            }
                        })
                        delete this.form_params.details;
                        delete this.form_params.statistic;
                        if(this.form_params.delivery_time!=0){
                            this.form_params.delivery_time = this.formatTime(this.form_params.delivery_time+"000")
                        }
                        if(this.form_params.predict_time!=0){
                            this.form_params.predict_time = this.formatTime(this.form_params.predict_time+"000")
                        }
                        if(this.form_params.sales_time!=0){
                            this.form_params.sales_time = this.formatTime(this.form_params.sales_time+"000")
                        }
                        this.form_params.rec=this.form_params.rec==1?true:false;
                        this.form_params.is_show_traffic=this.form_params.is_show_traffic==1?true:false;
                        this.form_params.is_discount_rate=this.form_params.is_discount_rate==1?true:false;
                        this.getBillMess(this.form_params.customer_id)
                        this.tableTotal.sales_amount = res.data.data.sales_amount;
                        this.tableTotal.discount_amount = res.data.data.discount_amount;
                        this.tableTotal.tax_amount = res.data.data.tax_amount;
                        this.tableTotal.traffic_amount = res.data.data.traffic_amount;
                        this.tableTotal.other_amount = res.data.data.other_amount;
                        this.tableTotal.reduce_amount = res.data.data.reduce_amount;
                        this.calculationTableTotal()
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }else if(obj.name=="invoice_yes"){
                    this.billRecoedParam.order_id = obj.id;
                    this.postFunc("/erp/invoice.list",this.billRecoedParam,res=>{
                        this.pl(res)
                        this.seeBillList_id = obj.id;
                        this.dialogVisibleBill = true;
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }else{
                    this.listDetailObj.order_id=obj.id;
                    let data=null;
                    this.list.forEach(item=>{
                        if(item.id==obj.id){
                            data=JSON.parse(JSON.stringify(item))
                        }
                    })
                    switch(obj.name){
                        case "traffic_amount":
                            this.listDetailObj.type=1;
                            this.listDetailObj.amount=data.traffic_amount;
                            this.listDetailObj.remark=data.traffic_amount_remark;
                            break;
                        case "tax_amount":
                            this.listDetailObj.type=2;
                            this.listDetailObj.amount=data.tax_amount;
                            this.listDetailObj.remark=data.tax_amount_remark;
                            break;
                        case "other_amount":
                            this.listDetailObj.type=3;
                            this.listDetailObj.amount=data.other_amount;
                            this.listDetailObj.remark=data.other_amount_remark;
                            break;
                        case "reduce_amount":
                            this.listDetailObj.type=4;
                            this.listDetailObj.amount=data.reduce_amount;
                            this.listDetailObj.remark=data.reduce_amount_remark;
                            break;
                    }
                    this.listDialogVisible=true;
                }
            },
            getPage(obj){
                this.params.page = obj.currentpage;
                this.params.per_page = obj.pagesize;
            },

            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.params.start_time = this.formatTimeZero(this.start_time);
                this.params.end_time = this.formatTimeZero(this.end_time);
                this.params.start_predict_time = this.formatTimeZero(this.start_predict_time);
                this.params.end_predict_time = this.formatTimeZero(this.end_predict_time);
                this.tableLoading = true;
                this.postFunc("/erp/receipt.notice",this.params,response=>{
                    this.last_page=parseInt(response.data.data.last_page);
                    // this.params.page=parseInt(response.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(response.data.data.total);
                    this.totalObj=response.data.data.count
                    // this.totalObj.outstanding_amount=parseFloat(response.data.data.outstanding_amount).toFixed(2);
                    // this.totalObj.reduce_amount=parseFloat(response.data.data.reduce_amount).toFixed(2);
                    // this.totalObj.receivable_amount=parseFloat(response.data.data.receivable_amount).toFixed(2);
                    // this.totalObj.sales_amount=parseFloat(response.data.data.sales_amount).toFixed(2);
                    this.list = response.data.data.data;
                    this.list.forEach((item,index)=>{
                        if(item.sales_time!=0){
                            this.list[index].sales_time = this.formatTime(item.sales_time+"000")
                        }else{
                            this.list[index].sales_time = "";
                        }
                        if(item.predict_time!=0){
                            this.list[index].predict_time = this.formatTime(item.predict_time+"000")
                        }else{
                            this.list[index].predict_time = "";
                        } 
                        if(item.settlement_time!=0){
                            this.list[index].settlement_time = this.formatTime(item.settlement_time+"000")
                        }else{
                            this.list[index].settlement_time = "";
                        }
                        if(Number(item.outstanding)!=0){
                            this.list[index].baseColor="#ff0000";
                        }else{
                            this.list[index].baseColor="";
                        }
                        // if(item.status==2){
                        //     item.baseColor="green"
                        // }else if(item.status==1){
                        //     item.baseColor="#B400FF"
                        // }else{
                        //     item.baseColor=""
                        // }
                        // item.isCanClickUnInclude=item.invoice_yes;
                        // this.list[index].sales_amount = parseFloat(item.sales_amount).toFixed(2);
                        // this.list[index].already_amount = parseFloat(item.already_amount).toFixed(2);
                        // this.list[index].outstanding = parseFloat(item.outstanding).toFixed(2);
                        // this.list[index].traffic_amount = parseFloat(item.traffic_amount).toFixed(2);
                        // this.list[index].tax_amount = parseFloat(item.tax_amount).toFixed(2);
                        // this.list[index].other_amount = parseFloat(item.other_amount).toFixed(2);
                        // this.list[index].reduce_amount = parseFloat(item.reduce_amount).toFixed(2);
                    })
                    this.last_page = response.data.data.last_page;
                    // this.summary.sales_amount = response.data.data.sales_amount;
                    // this.summary.reduce_amount = response.data.data.reduce_amount;
                    // this.summary.already_amount = response.data.data.already_amount;
                    // this.summary.outstanding_amount = response.data.data.outstanding_amount;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },

            search(){
                if (this.params.page == 1) {
                    this.getList()
                } else {
                    this.params.page = 1;
                }
            },

            reset(){
                this.params.order_sn = "";
                this.params.sales_time = "";
                this.params.start_time = "";
                this.params.end_time = "";
                this.params.start_predict_time = "";
                this.params.end_predict_time = "";
                this.start_predict_time = "";
                this.end_predict_time = "";
                this.start_time = "";
                this.end_time = "";
                this.params.customer_id = "";
                this.params.salesman_id = "";
                this.params.settlement_status = "";
                this.params.rec = "";
                this.params.status = "";
                this.$refs['selectdowncustomer'].clearData()
                this.getList();
            },

            // 审核通过
            OrderOut(id){
                this.$confirm('是否确定审核通过?', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                }).then(() => {
                    this.postFunc("/erp/finance.allow.shipping",{order_ids : id.toString()},()=>{
                        this.tip("审核成功","success")
                        // this.dialogVisible=false;
                        this.form_params.isOrderOutPass = false;
                        this.getList();
                    },error=>{
                        this.tip(error.data.message,"warning")
                    })
                }).catch(()=>{})
            },
            batchOrderOut(){
                if(this.selectRow.length<1){
                    this.tip("请选择销售单","warning")
                }else{
                    let flag = true;
                    let arr = new Array();
                    for(let i=0;i<this.selectRow.length;i++){
                        if(!this.selectRow[i].isOrderOutPass){
                            flag = false;
                            this.tip("选择订单中有不可出库项","warning")
                            return;
                        }else{
                            arr.push(this.selectRow[i].id)
                        }
                    }
                    if(flag){
                        this.OrderOut(arr)
                    }
                }
            },
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "addDialogVisible":function(val){
                if(!val){
                    this.add_params=this.resetJson(this.add_params)
                    this.add_params.course_title="进销货款";
                }
            },
            'addDialogVisibleBill':function(val){
                if(!val){
                    this.add_billParams=this.resetJson(this.add_billParams)
                }else{
                    this.$refs['selectStock'].getList();
                }
            },
            "sureDialogVisible":function(val){
                if(!val){
                    this.sure_params=this.resetJson(this.sure_params)
                }
            },
            "listDialogVisible":function(val){
                if(!val){
                    this.listDetailObj=this.resetJson(this.listDetailObj)
                }
            }
        }
    }
</script>
